import React from 'react';

export default function ServiceAreaMap() {
  const areas = [
    { city: 'Vancouver', description: 'High-density urban projects and commercial developments' },
    { city: 'Burnaby', description: 'Mixed-use developments and hillside construction' },
    { city: 'Surrey', description: 'Rapid expansion residential and commercial projects' },
    { city: 'Coquitlam', description: 'Hillside terrain and high-density residential' },
    { city: 'New Westminster', description: 'Urban riverfront and heritage area projects' },
    { city: 'Langley', description: 'Fraser Valley expansion and new developments' },
    { city: 'Richmond', description: 'Commercial and residential construction' },
    { city: 'Delta', description: 'Industrial and residential projects' },
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Lower Mainland Coverage
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            We serve construction projects across all major cities in the Lower Mainland and Fraser Valley region.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-12">
          <div className="aspect-video w-full bg-gradient-to-br from-teal-50 to-slate-100">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d332892.8827123456!2d-123.1939529!3d49.2608724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548673f143a94fb3%3A0xbb9196ea9b81f38b!2sVancouver%2C%20BC!5e0!3m2!1sen!2sca!4v1234567890123!5m2!1sen!2sca"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Lower Mainland Service Area"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {areas.map((area) => (
            <div
              key={area.city}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-teal-100 rounded-lg mb-4">
                <i className="ri-map-pin-line text-2xl text-teal-600" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">{area.city}</h3>
              <p className="text-sm text-slate-600">{area.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
